import { createSlice } from "@reduxjs/toolkit";

const forecastReportTypeSlice = createSlice({
  name: "forecastReportType",
  initialState: { selectedforecastReportType: "default" },
  reducers: {
    setforecastReportType(state, action) {
      state.selectedforecastReportType = action.payload.selectedforecastReportType;
    }
  },
});

export const forecastReportTypeActions = forecastReportTypeSlice.actions;

export default forecastReportTypeSlice;
